import { Typography } from 'antd'
import { WrapperProps } from './types'

/**
 * @example
 * No Recipients have been configured to receive an email for {children} Request For Information
 * No Recipients have been configured to receive an email for {children} of the Request For Information
 */
const Wrapper: React.FC<WrapperProps> = ({ children, ofThe }) => {
  return (
    <Typography.Text>
      No Recipients have been configured to receive an email for {children}
      {ofThe === false ? '' : ' of the'} Request For Information
    </Typography.Text>
  )
}

export default Wrapper
